// Copyright 2026, Imprivata, Inc.  All rights reserved.

import { Entitlement } from '@api/constants';
import { hasEntitlement } from '@api/utils';
import { useSession } from '@common/authorization/context/Session';
import { AuthnLevel } from '@portal/containers/security/constants';
import { useTranslation } from 'react-i18next';
import { featureSupported } from '@/featureFlagsUtils';
import FieldSelect from './FieldSelect';
import './Workflows.less';
import WorkstationSettings from './WorkstationSettings';

const SECURITY = 'portal.security';

const Workflows = () => {
  const { t } = useTranslation();
  const { tenantInfo } = useSession();
  const enableEpcs =
    featureSupported('ENABLE_EPCS') && hasEntitlement(tenantInfo, Entitlement.EPCS);

  return (
    <div className="workflows workflows-card">
      {enableEpcs && (
        <section className="workflows-epcs" aria-label={t(`${SECURITY}.epcs-field-label`)}>
          <FieldSelect
            label={t(`${SECURITY}.epcs-field-label`)}
            value={AuthnLevel.ICP_MFA}
            options={[{ value: AuthnLevel.ICP_MFA, label: t(`${SECURITY}.epcs-mfa-option`) }]}
            disabled
          />
        </section>
      )}
      <WorkstationSettings />
    </div>
  );
};

export default Workflows;
